
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/mtg-lorwyn-eclipsed",
      function () {
        return require("private-next-pages/landing/mtg-lorwyn-eclipsed.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/mtg-lorwyn-eclipsed"])
      });
    }
  